import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import React, { PropsWithChildren, ReactElement, ReactNode } from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
  UseFormReturn,
} from 'react-hook-form';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY';

export interface FormDatePickerProps<T extends object> {
  form: UseFormReturn<T>;
  label: ReactNode;
  fieldName: Path<T>;
  format?: string;
  placeholder?: string;
  validation?: RegisterOptions;
}
export const FormDatePicker = <T extends FieldValues>(
  props: PropsWithChildren<FormDatePickerProps<T>>,
): ReactElement | null => {
  const { form, label, fieldName, validation, format } = props;
  return (
    <Controller
      control={form.control as Control<FieldValues>}
      name={fieldName}
      rules={validation}
      render={({ field: { onChange, onBlur, value, name } }) => {
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker']}>
              <DatePicker
                label={label}
                name={name}
                onChange={(newValue) => {
                  const formattedValue = newValue ? dayjs(newValue).format(DATE_FORMAT) : '';
                  onChange(formattedValue);
                }}
                onAccept={(newValue) => {
                  const formattedValue = newValue ? dayjs(newValue).format(DATE_FORMAT) : '';
                  onChange(formattedValue);
                  onBlur();
                }}
                value={value ? dayjs(value.substring(0, 10)) : null}
                defaultValue={value ? dayjs(value.substring(0, 10)) : null}
                format={format || DATE_DISPLAY_FORMAT}
                closeOnSelect={true}
                onClose={onBlur}
                sx={{width: '100%', marginTop: "8px !important"}}
              />
            </DemoContainer>
          </LocalizationProvider>
        );
      }}
    />
  );
};
